import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

import { toDollars } from "../../../helpers/currencies";
import { CRMAppLocationIdentifier, FaqProps } from "../../../types/Faq";

const DossierCategoryTotalRow = ({
  label,
  values,
  isTotal = false,
  textSize = "medium",
  faqs,
  faqAppLocationIdentifier,
  targetUrls,
  decimalPlaces = 0,
}: {
  label: string;
  values: number[];
  isTotal: boolean;
  textSize?: "small" | "medium";
  faqs?: FaqProps;
  faqAppLocationIdentifier?: CRMAppLocationIdentifier;
  targetUrls?: string[];
  decimalPlaces?: number;
}) => {
  const navigate = useNavigate();
  const renderAppLocation = faqs?.renderAppLocation;
  const totalFontSize = textSize === "small" ? "titleSmall" : "titleLarge";
  const valueFontSize = textSize === "small" ? "titleSmall" : "titleMedium";
  const lastVal = values.length > 0 ? values[values.length - 1] : undefined;
  let color: string;

  if (lastVal !== undefined && lastVal <= 0) {
    color = "secondary.main";
  } else if (lastVal !== undefined && lastVal <= 100) {
    color = "primary.main";
  }

  const renderValue = (value: number, index: number, targetUrl?: string) => {
    const valueElement = (
      <Typography
        variant={isTotal ? totalFontSize : valueFontSize}
        color={color}
        onClick={targetUrl ? () => navigate(targetUrl) : undefined}
        sx={{ cursor: targetUrl ? "pointer" : undefined }}
      >
        {value !== undefined ? toDollars(value, decimalPlaces) : ""}
      </Typography>
    );
    return (
      <Box sx={{ flex: 1, display: "flex", justifyContent: "end" }} key={index}>
        {renderAppLocation && faqAppLocationIdentifier && !targetUrl
          ? renderAppLocation(faqAppLocationIdentifier, valueElement)
          : valueElement}
      </Box>
    );
  };

  const labelElement = (
    <Typography variant={isTotal ? totalFontSize : valueFontSize}>
      {label}
    </Typography>
  );
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "start",
        border: isTotal ? "1px solid" : "none",
        borderLeft: "none",
        borderRight: "none",
        borderColor: "outlineVariant.main",
        py: isTotal ? 0.5 : undefined,
      }}
    >
      <Box sx={{ flex: 1 }}>
        {renderAppLocation && faqAppLocationIdentifier
          ? renderAppLocation(faqAppLocationIdentifier, labelElement)
          : labelElement}
      </Box>
      {values.map((value, index) =>
        renderValue(value, index, targetUrls?.[index])
      )}
    </Box>
  );
};

export default DossierCategoryTotalRow;
